<template>
  <div
      class="ai-visibility-data-table-row"
      :class="{
      'ai-visibility-data-table-row--header': header,
      'ai-visibility-data-table-row--fill': fill,
      'ai-visibility-data-table-row--clickable': clickable,
    }"
      role="row"
      :tabindex="clickable ? 0 : null"
      @click="handleClick"
      @keyup.enter="handleClick"
  >
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'DataTableRow',
  props: {
    header: {
      type: Boolean,
      default: false,
    },
    fill: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick(event) {
      if (this.clickable) {
        this.$emit('click', event)
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-data-table-row {
  position: relative;
  display: flex;
  min-height: 44px;
  align-items: center;
  justify-content: space-between;
}

.ai-visibility-data-table-row::after {
  position: absolute;
  right: 20px;
  bottom: 0;
  left: 20px;
  border-bottom: 1px dashed var(--v-gray12Color-base);
  content: '';
  pointer-events: none;
}

.ai-visibility-data-table-row--header {
  min-height: 44px;
  //border-bottom: 1px solid #DADADA;

  &::after {
    position: absolute;
    right: 20px;
    bottom: 0;
    left: 20px;
    border-bottom: 1px solid var(--v-gray12Color-base) !important;
    content: '';
    pointer-events: none;
  }
}

.ai-visibility-data-table-row--fill {
  background-color: var(--v-pink1Color-base);
  border-top: 1px solid #DADADA;

  &::after {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    border-bottom: 1px solid var(--v-gray12Color-base) !important;
    content: '';
    pointer-events: none;
  }
}


.ai-visibility-data-table-row--header::after {
  border-bottom-style: solid;
}

.ai-visibility-data-table-row--header ::v-deep .ai-visibility-data-table-cell {
  color: var(--v-mainColor3-base);
  font-size: 16px;
  font-weight: 700;

  &:first-child {
    border-right: none;
  }
}

.ai-visibility-data-table-row--clickable {
  cursor: pointer;
}

.ai-visibility-data-table-row--clickable:focus {
  outline: 2px solid var(--v-lightYellowColor-base);
  outline-offset: -2px;
}
</style>
